import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";

const Application_shopactlicense = () => {
  const { id } = useParams();
  const [licenseData, setLicenseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [showDocument, setShowDocument] = useState(null);
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];
  const navigate = useNavigate()
  const [isRejected, setIsRejected] = useState(false);
  var [dbstutus, setdbstutus] = useState();

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/shopActLicense/getShopActLicense/${id}`
        );
        const fetchedData = response.data || {};

        setLicenseData(response.data)
        // if (fetchedData.Status === "Rejected") {
        //   setIsRejected(true);
        
        // }
        setdbstutus(fetchedData.Status);

        if (fetchedData.Status === "Rejected" || fetchedData.Status === "Completed") {
          setIsRejected(true);  
     } else {
         setIsRejected(false); 
     }
      } catch (err) {
        setError("Error fetching license data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);


  const getStatusOptions = (dbstutus) => {
    switch (dbstutus) {
      case "In-Progress":
        return [ "Submitted", "Rejected"];
      case "Submitted":
        return ["Completed"];
      case "Rejected":
        return ["Rejected", "Submitted"];
      case "Completed":
        return ["Completed"];
      default:
        return ["In-Progress"];
    }
  };



  const handleUpdate = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("rejectedNote", licenseData.rejectedNote);
    formData.append("Status", licenseData.Status);

    if (licenseData.Status === "Submitted") {
      formData.append("submitNote", licenseData.submitNote || "");

    } if (licenseData.Status === "Completed") {
      formData.append("completedNote", licenseData.completedNote || "");
    }


    for (const [key, value] of Object.entries(files)) {
      formData.append(`documents.${key}`, value);
    }

    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/shopActLicense/updateShopActLicense/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      showCustomToast(response.data.message);
      console.log("data after update", response)
      if (licenseData.Status === "Rejected") {
        navigate('/admin/rejectedapplicationconsole');
      } else if (licenseData.Status === "Submitted") {
        navigate("/admin/submitapplicationconsole");
      } else if (licenseData.Status === "In-Progress") {
        navigate('/admin/inprogressapplicationconsole');
      } else if (licenseData.Status === "Completed") {
        navigate("/admin/completedapplicationconsole");
      }


      const updatedLicense = await axios.get(
        `https://api.makeeasydocuments.com/api/shopActLicense/getShopActLicense/${id}`
      );
      const updatedData = updatedLicense.data || {};
      setLicenseData(updatedData);

    } catch (error) {
      showCustomToast("Failed to update license.", "error");
    }
  }




  const handleFileChange = (event) => {
    const { name, files } = event.target;
    const file = files[0];

   // Handle the receipt file validation
          if (name === "receipt") {
              const fileType = file.type;
              const fileSize = file.size;
            
              const validReceiptTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
            
              const minSize = 75 * 1024; // 75 KB
              const maxSize = 5 * 1024 * 1024; // **Increased to 5 MB**
            
              // Check if the file type and size are valid
              if (validReceiptTypes.includes(fileType) && fileSize >= minSize && fileSize <= maxSize) {
                // Valid file: Set the file
                setFiles({ ...files, [name]: file });
              } else {
                // Invalid file: Show error message and reset input
                showCustomToast('Invalid file. File must be a PDF, JPG, JPEG, PNG and between 75KB to 5MB in size.', 'error');
                event.target.value = '';  // Clear the file input
              }
            } else {
              // Handle other file inputs if necessary
              setFiles({ ...files, [name]: file });
            }
  };

  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData &&
        imageData.contentType &&
        imageData.data &&
        imageData.data.data &&
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };
  
  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-40">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-90%">
          <h2>Download The Documents From Here...</h2>

          <div className="my-4">
            <img
              src={document}
              alt="pdf preview"
              className="max-w-full max-h-96 mx-auto"
              onError={(e) => {
                e.target.onerror = null;
               
                
              }}
            />
          </div>

          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            <a
              href={document}
              download
              className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
            >
              Download
            </a>
          </div>
        </div>
      </div>
    );
  };

  const DownloadableDocuments = () => {
    console.log("License Data Documents:", licenseData.documents); // Debug log
    if (!licenseData.documents) return null; // Ensure documents is defined

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {Object.entries(licenseData.documents).map(([key, value]) => (
            <div
              key={key}
              className="border p-4 rounded-lg text-center bg-gray-50 shadow"
            >
              <h3 className="font-semibold mb-2 text-gray-700 tracking-normal">
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => {
                  const imageUrl = renderImage(value);
                  setShowDocument(imageUrl);
                }}
              >
                Open Document
              </button>
            </div>
          ))}
          {Object.keys(licenseData.documents).length === 0 && (
            <p className="text-gray-600">No documents available</p>
          )}
        </div>
      </div>
    );
  };
  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error) return <div className="text-center mt-10 text-red-500">{error}</div>;
  if (!licenseData) return <div>No data found</div>;


  return (
    <div className="p-4 sm:p-6 md:p-8 mt-5 mb-10 max-w-6xl mx-auto bg-gray-200 rounded-lg shadow-lg">
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 mb-8">
        Shop act license Application
      </h1>

      {/* License Data */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        <div className="bg-white shadow-md p-4 sm:p-6 rounded-lg space-y-4">
          <h2 className="text-lg font-bold text-center text-gray-700 border-b-2 border-gray-400 pb-2">
            Personal Information
          </h2>
          {[
            { label: "Full Name (English)", value: licenseData.fullName },
            {
              label: "Full Name (Marathi)",
              value: licenseData.fullNameMarathi,
            },
            { label: "Contact Number", value: licenseData.mobileNumber },
            { label: "Email", value: licenseData.email },
            { label: "Gender", value: licenseData.gender },
            {
              label: "Date of Birth",
              value: new Date(licenseData.dateOfBirth).toLocaleDateString(),
            },
            { label: "Address (English)", value: licenseData.addressEnglish },
            { label: "Address (Marathi)", value: licenseData.addressMarathi },
            {
              label: "Years In Residence",
              value: licenseData.noofYearsInResidency,
            },
            { label: "Shop Name", value: licenseData.shopName },
            {
              label: "Shop Name (Marathi)",
              value: licenseData.shopNameMarathi,
            },
            {
              label: "Nature Of Business",
              value: licenseData.natureOfBusiness,
            },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between text-gray-800">
              <strong className="text-gray-600 w-1/2">{label} :</strong>
              <span className="w-3/4 text-gray-700 border border-gray-300 bg-gray-50 p-2 rounded">
                {value}
              </span>
            </div>
          ))}
        </div>

        <div className="bg-white shadow-md p-4 sm:p-6 rounded-lg space-y-4">
          <h2 className="text-lg font-bold text-center text-gray-700 border-b-2 border-gray-400 pb-2">
            Additional Information
          </h2>
          {[
            {
              label: "Nature Of Business (Marathi)",
              value: licenseData.natureOfBusinessMarathi,
            },
            { label: "Shop Address", value: licenseData.shopAddress },
            {
              label: "Shop Address (Marathi)",
              value: licenseData.shopAddressMarathi,
            },
            { label: "Shop Pincode", value: licenseData.shopPincode },
            { label: "Is Shop Rented", value: licenseData.isShopRented },
            { label: "Male Employees", value: licenseData.noOfMaleEmployess },
            {
              label: "Female Employees",
              value: licenseData.noOfFemaleEmployess,
            },
            { label: "Partner Full Name", value: licenseData.partnerFullName },
            { label: "Partner Number", value: licenseData.partnerNumber },
            { label: "Partner Email", value: licenseData.partnerFullEmail },
            { label: "Partner Address", value: licenseData.partnerFullAddress },
            { label: "Aadhar Number", value: licenseData.aadharNumber },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between text-gray-800">
              <strong className="text-gray-600 w-1/2">{label} :</strong>
              <span className="w-3/4 text-gray-700 border border-gray-300 bg-gray-50 p-2 rounded">
                {value}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Application Status */}
      {/* Documents Section */}
      <div className="bg-white shadow-md p-4 sm:p-6 rounded-lg mb-10">
        <h2 className="text-lg sm:text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
          Application Documents
        </h2>
        <DownloadableDocuments />

{/* Modal for Viewing Document */}
{showDocument && (
  <DocumentPreviewModal
    document={showDocument}
    onClose={() => setShowDocument(null)}
  />
)}
      </div>

      
      {/* Update Form Section */}
      <div className="flex flex-col lg:flex-row">
        {/* Update Form */}
        <div className='bg-white shadow-md p-4 sm:p-6 rounded-lg mb-6 lg:mb-0 lg:mr-4 w-full lg:w-1/2'>
          <h2 className="text-lg sm:text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
            Update License Application
          </h2>
          <form onSubmit={handleUpdate} className="space-y-6">
            {/* Status Selection - Only show available options based on current status */}
            <div className="space-y-4">
              <label className="block text-gray-700 font-semibold">
                Status:
              </label>
              <select
                name="Status"
                // value={licenseData.Status}
                value={licenseData.Status || dbstutus || ""}

                onChange={(e) =>
                  setLicenseData({ ...licenseData, Status: e.target.value })
                }
                defaultValue={dbstutus || ""}

                required
                className="block w-full p-2 border rounded-lg bg-gray-50"
              >
              
                                <option hidden>Select Status</option>
                {getStatusOptions(dbstutus).map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}

              </select>
            </div>

            {/* Show Rejected Note only for Rejected status */}
            {licenseData.Status === "Rejected" && (
              <div className="space-y-4">
                <label className="block text-gray-700 font-semibold">
                  Rejection Note:
                </label>
                <textarea
                  name="rejectedNote"
                  value={licenseData.rejectedNote || ""}
                  onChange={(e) =>
                    setLicenseData({
                      ...licenseData,
                      rejectedNote: e.target.value,
                    })
                  }
                  className="block w-full p-2 border rounded-lg bg-gray-50"
                  rows="2"
                  required
                ></textarea>
              </div>
            )}

            {/* Show Submit fields only for Submitted status */}
            {licenseData.Status === "Submitted" && (
              <div className="space-y-4">
                <label className="block text-gray-700 font-semibold">
                  Upload Receipt:
                </label>
                <input
                  type="file"
                  name="receipt"
                  onChange={handleFileChange}
                  className="block w-full p-2 border rounded-lg bg-gray-50"
                  accept="image/*,.pdf"
                  required
                />
                <br /><span className='text-red-600 text-xs'>(Max Size: PDF,JPG,JPEG / 75kb to 1mb)</span>


                <label className="block text-gray-700 font-semibold">
                  Submission Note:
                </label>
                <textarea
                  name="submitNote"
                  value={licenseData.submitNote || ""}
                  onChange={(e) =>
                    setLicenseData({
                      ...licenseData,
                      submitNote: e.target.value,
                    })
                  }
                  className="block w-full p-2 border rounded-lg bg-gray-50"
                  rows="2"
                  required
                ></textarea>
              </div>
            )}

            {/* Show Completed fields only for Completed status */}
            {licenseData.Status === "Completed" && (
              <div className="space-y-4">
                <label className="block text-gray-700 font-semibold">
                  Upload Finished Document:
                </label>
                <input
                  type="file"
                  name="finisheddoc"
                  onChange={handleFileChange}
                  className="block w-full p-2 border rounded-lg bg-gray-50"
                  accept="image/*,.pdf"
                  required
                />

                <label className="block text-gray-700 font-semibold">
                  Completion Note:
                </label>
                <textarea
                  name="completedNote"
                  value={licenseData.completedNote || ""}
                  onChange={(e) =>
                    setLicenseData({
                      ...licenseData,
                      completedNote: e.target.value,
                    })
                  }
                  className="block w-full p-2 border rounded-lg bg-gray-50"
                  rows="2"
                  required
                ></textarea>
              </div>
            )}

            
            <button
              type="submit"
              className={`block w-full py-2 px-4 rounded ${isRejected ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700 text-white"
                }`}
              disabled={isRejected}
            >
              Submit
            </button>


          </form>
        </div>

        {/* Application History */}
        <div className="bg-green-50 shadow-md p-6 rounded-lg w-full lg:w-1/2 space-y-4">
          <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
            Application History
          </h2>

          <div className="flex justify-between text-gray-800">
            <strong className="text-gray-600 flex-1">
              Created At (Date & Time):
            </strong>
            <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
              {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true, // Change to true for 12-hour format
              })}
            </span>
          </div>

          <div className="flex justify-between text-gray-800">
            <strong className="text-gray-600 flex-1">
              Updated At (Date & Time):
            </strong>
            <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
              {licenseData.updatedAt
                ? new Date(licenseData.updatedAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: true, // Change to true for 12-hour format
                })
                : "N/A"}
            </span>
          </div>

          <div className="flex justify-between text-gray-800">
            <strong className="text-gray-600 flex-1">Current Status:</strong>
            <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
              {/* {licenseData.Status ? licenseData.Status : "N/A"} */}
              {dbstutus}

            </span>
          </div>
        </div>
      </div>

      <CustomToastContainer />
    </div>
  );
};

export default Application_shopactlicense;
